import { isRef, isReactive, set } from "vue";
import { cloneDeep } from "lodash-es";
/**
 * Sets default values to form object from formFields if value is nullish
 * If validationObject is provided then check if user has touched input and if so
 * prevent setting default value to it
 * @param form
 * @param formFields
 * @param options.validationObject specifically v$.[form name here] object to prevent setting value if user has made input dirty
 * @param options.mapModel if UI side has different field name than what server returns
 * @param options.overwriteFields specific fields that shuold be overwritten
 * @param {Boolean} options.forceReturn return form value even if its ref or reactive
 * @returns If not reactive nor ref then returns new object with formFields default values set.
 * Objects declared in data() scope are reactive
 * Otherwise return undefined as ref/reactive gets mutated instead
 */
export function setDefaultValuesFromFormField(form, formFields, options = {}) {
    const formIsRef = isRef(form);
    const formIsReactive = isReactive(form);
    const { overwriteFields = [] } = options;
    const rawForm = {};
    formFields.forEach(ff => {
        var _a, _b, _c, _d;
        const currentValue = formIsRef ? form.value[ff.name] : form[ff.name];
        const fieldName = (_b = (_a = options === null || options === void 0 ? void 0 : options.mapModel) === null || _a === void 0 ? void 0 : _a[ff.name]) !== null && _b !== void 0 ? _b : ff.name;
        const defaultValue = cloneDeep(ff.defaultValue);
        if (overwriteFields.includes(fieldName) ||
            ((isNullish(currentValue) ||
                isEmptyArray(currentValue) ||
                isEmptyObject(currentValue)) &&
                !((_d = (_c = options.validationObject) === null || _c === void 0 ? void 0 : _c[fieldName]) === null || _d === void 0 ? void 0 : _d.$dirty))) {
            if (formIsRef)
                form.value[fieldName] = defaultValue;
            else if (formIsReactive)
                set(form, fieldName, defaultValue);
            // set is for vue 2
            //form[fieldName] = ff.defaultValue;
            else
                rawForm[fieldName] = defaultValue;
        }
    });
    if (options.forceReturn)
        return { ...form, ...rawForm };
    if (!formIsRef && !formIsReactive)
        return { ...form, ...rawForm };
    return undefined;
}
function isNullish(v) {
    return undefined == v;
}
function isEmptyArray(v) {
    return Array.isArray(v) && v.length == 0;
}
function isEmptyObject(v) {
    if (isNullish(v))
        return false; // nullish is object too
    return (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length == 0);
}
